module.exports = __webpack_public_path__ + "static/img/藏青工业园区.6d9fffef.jpg";